module.exports = __webpack_public_path__ + "img/1.1.23fbb337.png";